import { GridItem } from '@bnnvara/grids';
import PropTypes from 'prop-types';
import React from 'react';

import ArticleCard from '../../components/cards/ArticleCard';
import Link from '../../components/Link';

const ComposableArticleCard = (props) => {
  const { slug, wide, index, type } = props;

  return (
    <GridItem
      columnEndSm="span 12"
      columnEndMd={wide ? 'span 12' : 'span 6'}
      columnEndLg={wide ? 'span 6' : 'span 3'}
      columnEndXl={wide ? 'span 6' : 'span 3'}
      key={slug}
    >
      <Link
        href={`/artikelen/${slug}`}
        category="Homepage"
        label={`${type}-${index}`}
        action="click"
      >
        <ArticleCard {...props} />
      </Link>
    </GridItem>
  );
};

ComposableArticleCard.defaultProps = {
  wide: false,
};

ComposableArticleCard.propTypes = {
  slug: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  wide: PropTypes.bool,
  index: PropTypes.number.isRequired,
};

export default ComposableArticleCard;
